import React from 'react'
import './loadspinner.css'

const LoadSpinner = () => {
  return (
    <div className="d-flex justify-content-center text-secondary">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

export default LoadSpinner